import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    color: '#4A4A4A',
    margin: '0.5rem 0 0.75rem 0',
    border: 0,
    borderBottom: '1px solid #C6C6C6',
    width: '100%',
    paddingBottom: '0.25rem',
    outline: 'none',
    fontSize: theme.size.base
  },

  editor: {
    '& .editor-input': {
      minHeight: '50px !important'
    }
  },

  buttons: {
    position: 'absolute',
    top: '-0.5rem',
    left: '2rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  button: {
    width: 'auto',
    padding: '0 1.5rem'
  }
}))

export default useStyles
